const Buffer = require('buffer/').Buffer;
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
const toBase64 = (str: any) => {
  const data = JSON.stringify(str);
  const buff = Buffer.from(data);
  const stringToBase64 = buff.toString('base64');
  return JSON.stringify(stringToBase64);
};
const toBase64String = (str: any) => {
  const buff = Buffer.from(str);
  const stringToBase64 = buff.toString('base64');
  return stringToBase64;
};
const fromBase64 = (str: string, initValue = {}) => {
  try {
    const data = Buffer.from(str, 'base64').toString('utf-8');
    return data ? JSON.parse(data) : initValue;
  } catch (error) {
    return initValue;
  }
};
const fromBase64String = (str: string, initValue = '') => {
  try {
    const data = Buffer.from(str, 'base64').toString('utf-8');
    return data;
  } catch (error) {
    return initValue;
  }
};

export { toBase64, fromBase64, toBase64String, fromBase64String };
